import React from 'react';
import styles from 'styles/layout/CareerHeaderSection.module.sass';

/**
 * CareerHeaderSection component - A header section for the careers page.
 *
 * @component
 * @returns {JSX.Element} The rendered CareerHeaderSection component.
 *
 * @example
 * // Example usage:
 * <CareerHeaderSection />
 */
const CareerHeaderSection: React.FC = () => (
  <section className={styles['header-section']}>
    <div className={styles['background-container']}>
      <h1 className={styles['section-title']}>Join the Team Behind Smarter Insights</h1>
      <p className={styles['section-paragraph']}>
        We are a passionate team of analysts, engineers, and creators working to make data more accessible, meaningful, and impactful. At Zerone Analytics, we&apos;re building a platform that helps people make better decisions through data.
      </p>
    </div>
  </section>
);

export default CareerHeaderSection;
